export const userInfo = state => state.userInfo;

export const lang = state => state.lang;

export const sideBarList = state => state.sideBarList;

export const sideBarListEN = state => state.sideBarListEN;
